import { useSelector } from "react-redux";
import { useAppDispatch } from "../../api/core/useAppDispatch";
import { lastPageToggle } from "../../api/features/last-page/actions";
import { getNavLastPage } from "../../api/features/last-page/selectors";
import useNav from "../nav/useNav";
import { useEffect, useRef } from "react";
import { apiMetaData } from "../../api/core/ViewerApiMetaData";
import { noticeInteraction } from "../../../../../services/monitoring";
import { LastPageNavType } from "../../api/features/last-page/types";

let notify = true;

export default function useLastPage() {
  const dispatch = useAppDispatch();
  const lastPage = useSelector(getNavLastPage);
  const { goToCFI, goToUrl } = useNav();
  const runNotify = useRef(notify);
  const prevLastPage = useRef(lastPage);
  notify = false; // notify once irrespective of number of instances

  const toggleLastPage = () => dispatch(lastPageToggle());

  useEffect(() => {
    if (
      runNotify.current &&
      lastPage &&
      lastPage.isToggled !== undefined &&
      prevLastPage.current !== lastPage
    ) {
      if (lastPage.isToggled) {
        goToCFI(
          lastPage.srcCfi,
          { focusCfi: lastPage.srcRelatedCfi },
          apiMetaData({ dontTrack: true })
        );
        noticeInteraction("back-to-page", { direction: "back" });
      } else {
        if (lastPage.destType === LastPageNavType.CFI) {
          goToCFI(lastPage.dest, apiMetaData({ dontTrack: true }));
        } else {
          goToUrl(lastPage.dest);
        }
        noticeInteraction("back-to-page", { direction: "forward" });
      }
      // dependant hook functions change
      // so need to be certain last page is actually different
      prevLastPage.current = lastPage;
    }
  }, [goToCFI, goToUrl, lastPage]);

  return {
    toggleLastPage,
    lastPage,
  };
}
